// extracted by mini-css-extract-plugin
export default {"wrapper":"kqUqluxKQoOuCnmQaTtE","titleWrapper":"_UJ90PY61EUL837AkDL7","titlesContainer":"QyHHIGD6ZNiIxDs7BWna","newNotebookBtn":"t0rR8qZ7s5zO2xlfowbm"};